import { useState, useEffect } from "react";
import {
  getStudentIdData,
  addData,
  updateData,
  deleteIdData as deleteGoal,
} from "../../../lib/goalstracker"; // API functions
import {
  getGoalStrackerIdData,
  addData as addFollowData,
  updateData as updateFollowData,
  deleteIdData,
} from "../../../lib/goalstrackerfollow";
import {
  Tab,
  Nav,
  Button,
  Table,
  Form,
  Row,
  Col,
  Accordion,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import AwardTracker from "../../pages/common/awardtracker";
import Awardslist from "../studentGrid/sublist/awardslist";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";
import Submission from "./submisson";

const goalTypes = [
  "volunteering",
  "personal_development",
  "physical_fitness",
  "exploration",
];

const InstractorAwardsControl = () => {
  let { slug } = useParams();
  const { profile } = useAuth();
  const studentId = slug;
  const [activeTab, setActiveTab] = useState("studentawards");
  const [goals, setGoals] = useState({
    volunteering: [],
    personal_development: [],
    physical_fitness: [],
    exploration: [],
  });

  useEffect(() => {
    const initializeGoals = async () => {
      try {
        const existingGoals = await getStudentIdData(studentId);
        if (existingGoals.length > 0) {
          const goalsWithTrackerData = await Promise.all(
            existingGoals.map(async (goal) => {
              const activities = await getGoalStrackerIdData(goal.id);
              return { ...goal, activities };
            })
          );
          const newGoals = {
            volunteering: goalsWithTrackerData
              .filter((goal) => goal.trackertype === "volunteering")
              .sort((a, b) => a.id - b.id),
            personal_development: goalsWithTrackerData
              .filter((goal) => goal.trackertype === "personal_development")
              .sort((a, b) => a.id - b.id),
            physical_fitness: goalsWithTrackerData
              .filter((goal) => goal.trackertype === "physical_fitness")
              .sort((a, b) => a.id - b.id),
            exploration: goalsWithTrackerData
              .filter((goal) => goal.trackertype === "exploration")
              .sort((a, b) => a.id - b.id),
          };

          setGoals(newGoals);
        }
      } catch (error) {
        console.error("Error initializing goals:", error);
      }
    };

    initializeGoals();
  }, [studentId]);
  console.log("goals",goals);

 
  const handleGoalUpdate = async (goalType, index, field, value) => {
    const updatedGoals = [...goals[goalType]];
    updatedGoals[index][field] = value;
    setGoals({ ...goals, [goalType]: updatedGoals });
    console.log("updatedGoals", updatedGoals[index]);
    const { activities, ...goalData } = updatedGoals[index];
    await updateData(goalData);
  };

  const handleActivityUpdate = async (
    goalType,
    goalIndex,
    activityIndex,
    field,
    value
  ) => {

    const updatedGoals = [...goals[goalType]];
    updatedGoals[goalIndex].activities[activityIndex][field] = value;

    setGoals({ ...goals, [goalType]: updatedGoals });
    await updateFollowData(updatedGoals[goalIndex].activities[activityIndex]);
  };

  const addActivity = async (goalType, goalIndex) => {
    const newActivity = {
      gtid: goals[goalType][goalIndex].id,
      fdate: null,
      fhour: null,
      fnotes: "",
    };

    const response = await addFollowData(newActivity);
    const updatedGoals = [...goals[goalType]];
    updatedGoals[goalIndex] = {
      ...updatedGoals[goalIndex],
      activities: [...updatedGoals[goalIndex].activities || [] ],
  };
  
    
    console.log("updatedGoals", updatedGoals[goalIndex]);
    updatedGoals[goalIndex].activities.push(response[0]);
    setGoals({ ...goals, [goalType]: updatedGoals });
  };
  const addNewGoal = async (goalType) => {
    const newGoal = {
      studentId: studentId,
      goaldesc: "",
      goaltype: "",
      goalcontact: "",
      trackertype: goalType,
      registerdate: new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
    };
    console.log("newGoal", newGoal);
    const response = await addData(newGoal);
    setGoals((prevGoals) => ({
      ...prevGoals,
      [goalType]: [...prevGoals[goalType], response[0]],
    }));
  };
  const deleteGoalWithActivities = async (goalType, goalIndex) => {
    const goal = goals[goalType][goalIndex];
    if (goal.activities && goal.activities.length > 0) {
      await Promise.all(
        goal.activities.map((activity) => deleteIdData(activity.id))
      );
    }
    await deleteGoal(goal.id);
    setGoals((prevGoals) => ({
      ...prevGoals,
      [goalType]: prevGoals[goalType].filter((_, index) => index !== goalIndex),
    }));
  };
  const removeActivity = async (goalType, goalIndex, activityIndex, activityId) => {
    await deleteIdData(activityId);
    const updatedGoals = [...goals[goalType]];
    updatedGoals[goalIndex].activities = updatedGoals[goalIndex].activities.filter((_, idx) => idx !== activityIndex);
    setGoals({ ...goals, [goalType]: updatedGoals });
  };

  const renderAccordions = (goalType) => {
    return (
      <>
        <Accordion defaultActiveKey="0">
          {goals[goalType].map((goal, index) => (
            <>
              <Accordion.Item eventKey={index.toString()} key={index}>
                <div className="d-flex justify-content-between">
                  <Accordion.Header>
                    {goalType.replace("_", " ").toUpperCase()} #{index + 1}
                  </Accordion.Header>
                  <Button
                    variant="danger"
                    onClick={() => deleteGoalWithActivities(goalType, index)}
                  >
                    Delete Goal
                  </Button>
                </div>

                <Accordion.Body>
            <h3>Register Date: {goal.registerdate}</h3>

                  <Form>
                    <Table striped bordered hover>
                      <tbody>
                      <tr>
                    <td colSpan={3}>
                      <Row className="d-flex align-items-center">
                        <Col xs={12} md={3}>
                          <h5>What is your goal?</h5>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={goal.goaldesc}
                              onChange={(e) =>
                                handleGoalUpdate(
                                  goalType,
                                  index,
                                  "goaldesc",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                        <Col xs={12} md={3}>
                        {goalType === "volunteering" && (
                          <ul>
                            <li>Hospitals / Schools / Libraries</li>
                            <li>Shelters / Senior Home / Veteran Help</li>
                            <li>Community Cleaning Project</li>
                            <li>Weekend School</li>
                            <li>Event Volunteer</li>
                          </ul>
                          )}
                          {goalType === "personal_development" && (
                            <ul>
                            <li>Job Shadow / Internship / Employment</li>
                            <li>College Courses / Online Course / Tutoring</li>
                            <li>Journalism / Photography / Film Editing</li>
                            <li>Mental Health</li>
                            <li>Kur-an Class</li>
                          </ul>
                          )}
                          {goalType === "physical_fitness" && (
                            <ul>
                            <li>GYM / Daily Exercise</li>
                            <li>Clubs</li>
                            <li>Team Practice</li>
                            <li>Walking / Running</li>
                            <li>Yoga / Pilates</li>
                            <li>Martial Arts</li>
                          </ul>)}
                          {goalType === "exploration" && (
                             <ul>
                             <li>Travel / Discover New Cultures</li>
                             <li>Outdoor Adventures</li>
                             <li>Learn a New Language</li>
                             <li>Attend Workshops</li>
                             <li>Explore Local History</li>
                           </ul>
                          )}
                          
                        </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr>
                    <td colSpan={3}>
                      <Row className="d-flex align-items-center">
                        <Col xs={12} md={3}>
                          <h5>
                            What activities or organizations will you
                            participate in?
                          </h5>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={goal.goaltype}
                              onChange={(e) =>
                                handleGoalUpdate(
                                  goalType,
                                  index,
                                  "goaltype",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                        <Col xs={12} md={3}>
                        {goalType === "volunteering" && (
                          <ul>
                            <li>Online Courses / Workshops</li>
                            <li>Skill Development Programs</li>
                            <li>Volunteering in Education</li>
                            <li>Networking Events</li>
                            <li>Personal Projects</li>
                          </ul>
                          )}
                          {goalType === "personal_development" && (
                             <ul>
                             <li>Online Courses / Workshops</li>
                             <li>Skill Development Programs</li>
                             <li>Volunteering in Education</li>
                             <li>Networking Events</li>
                             <li>Personal Projects</li>
                           </ul>)}
                           {goalType === "physical_fitness" && (
                               <ul>
                               <li>Fitness Classes</li>
                               <li>Sports Teams</li>
                               <li>Marathons</li>
                               <li>Outdoor Activities</li>
                               <li>Health Challenges</li>
                             </ul>)}
                             {goalType === "exploration" && (
                              <ul>
                              <li>Cultural Festivals</li>
                              <li>Outdoor Clubs</li>
                              <li>Language Exchange Programs</li>
                              <li>Travel Groups</li>
                              <li>Workshops and Seminars</li>
                            </ul>)}
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      <Row className="d-flex align-items-center">
                        <Col xs={12} md={3}>
                          <h5>
                            What activities or organizations will you
                            participate in?
                          </h5>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={goal.goalcontact}
                              onChange={(e) =>
                                handleGoalUpdate(
                                  goalType,
                                  index,
                                  "goalcontact",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                      </Row>
                    </td>
                  </tr>
                      </tbody>
                    </Table>
                    {/* <Button className="m-1" onClick={() => handleGoalUpdate(goalType, index)}>
                      Update Goal
                    </Button> */}
                  </Form>
                  <Form>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
        
                          <th>Date</th>
                          <th>Hour</th>
                          <th>Notes</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {goal?.activities?.map((activity, idx) => (
                          <tr key={idx}>
                              
                            <td>
                              <Form.Control
                                type="date"
                                value={activity.fdate}
                                onChange={(e) =>
                                  handleActivityUpdate(
                                    goalType,
                                    index,
                                    idx,
                                    "fdate",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                value={activity.fhour}
                                onChange={(e) =>
                                  handleActivityUpdate(
                                    goalType,
                                    index,
                                    idx,
                                    "fhour",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                value={activity.fnotes}
                                onChange={(e) =>
                                  handleActivityUpdate(
                                    goalType,
                                    index,
                                    idx,
                                    "fnotes",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Button variant="danger" onClick={() => removeActivity(goalType, index, idx, activity.id)}>Remove</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-between">
                    <Button className="m-1" onClick={() => addActivity(goalType, index)}>
                      Add Activity
                    </Button>
                    {/* <Button
                    className="m-1"
                      onClick={() => handleActivityUpdate(goalType, index)}
                    >
                      Update Activities
                    </Button> */}

                    </div>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            </>
          ))}
        </Accordion>

        <Button onClick={() => addNewGoal(goalType)}>Add New Goal</Button>
      </>
    );
  };

  return (
    <div>
      <PageNotes
        type={"Instructor"}
        pageName={"Awards"}
        studentId={slug}
        instructorId={profile.id}
      />
      <Tab.Container
        defaultActiveKey="programdetails"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
      >
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="studentawards">Student Awards</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="programdetails">Program Details</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="volunteering">Volunteering</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="personal_development">
              Personal Development
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="physical_fitness">Physical Fitness</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="exploration">Exploration</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="submission">Submission</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="studentawards">
           <Awardslist slug={slug} show={true}/>
          </Tab.Pane>
          <Tab.Pane eventKey="programdetails">
            <AwardTracker />
          </Tab.Pane>
          <Tab.Pane eventKey="volunteering">
            {renderAccordions("volunteering")}
          </Tab.Pane>
          <Tab.Pane eventKey="personal_development">
            {renderAccordions("personal_development")}
          </Tab.Pane>
          <Tab.Pane eventKey="physical_fitness">
            {renderAccordions("physical_fitness")}
          </Tab.Pane>
          <Tab.Pane eventKey="exploration">
            {renderAccordions("exploration")}
          </Tab.Pane>
            <Tab.Pane eventKey="submission">
              {goals.volunteering.length > 0 ? (
                <Submission
                  volunteeringGoals={goals.volunteering}
                  personalDevelopmentGoals={goals.personal_development}
                  physicalFitnessGoals={goals.physical_fitness}
                  explorationGoals={goals.exploration}
                />
              ) : (
                <p>Loading...</p>
              )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default InstractorAwardsControl;
